

import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';
 
const useGetDischargeSummaryData = () => {
    const mutation = useMutation(
        async (payload) => {
            const response = await SrxApi.post(
                '/dischargesummary/pdf',
                payload,
                { responseType: 'blob' }
            );
 
            return {
                blob: response.data,
                headers: response.headers,
            };
        },
        {
            onSuccess: ({ blob, headers }) => {
                if (!blob) {
                    toast.error('No PDF file received');
                    return;
                }
 
                const contentType = headers?.['content-type'] || 'application/pdf';
 
                if (contentType.includes('application/json')) {
                    blob.text().then((text) => {
                        try {
                            toast.error(JSON.parse(text)?.message || 'Failed to generate discharge summary');
                        } catch {
                            toast.error('Failed to generate discharge summary');
                        }
                    });
                    return;
                }
 
                const fileUrl = window.URL.createObjectURL(
                    new Blob([blob], { type: 'application/pdf' })
                );
                const link = document.createElement('a');
                link.href = fileUrl;
                link.download = 'discharge-summary.pdf';
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(fileUrl);
            },
            onError: (error) => {
                toast.error(
                    error?.response?.data?.message ||
                    'Failed to fetch active medication list'
                );
            },
        }
    );
 
    return {
        getDischargeSummaryData: mutation.mutateAsync,
        isGetDischargeSummaryDataLoading: mutation.isPending,
    };
};
 
export default useGetDischargeSummaryData;
 